import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./MapDeviceToSite.css"; // ✅ SAME CSS FILE KEPT
import apiService from "../../utils/apiservice";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const MapDeviceToCustomer = () => {
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [assignedDevices, setAssignedDevices] = useState([]);
  const [availableDevices, setAvailableDevices] = useState([]);

  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const token = localStorage.getItem("accessToken");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    message: "",
  });
  // =============================
  // RESET PAGINATION
  // =============================
  useEffect(() => {
    setPage(0);
  }, [tabValue, selectedCustomer]);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getConfig = () => ({
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  // =============================
  // FETCH CUSTOMERS
  // =============================
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await apiService({
          url: `/api/get_customers/`,
          method: "GET",
          data: {},
        });

        const customerData = res.data || [];
        setCustomers(customerData);

        if (customerData.length > 0) {
          setSelectedCustomer(customerData[0].tb_customer_id);
        }
      } catch (err) {
        toast.error("Failed to fetch customers");
      }
    };

    fetchCustomers();
  }, []);

  // =============================
  // FETCH DEVICES (CUSTOMER LEVEL)
  // =============================
  const fetchDevices = async (customerId) => {
    try {
      setLoading(true);

      // 1️⃣ Fetch assigned devices for selected customer
      const assignedResp = await apiService({
        url: `/api/get_customer_devices_for_cust_assign/${customerId}/`,
        method: "GET",
        data: {},
        params: {
          page: 0,
          pageSize: 1000,
        },
      });
      console.log(assignedResp);


      // const assignedList =
      //   assignedResp?.data?.devices ||
      //   assignedResp?.devices ||
      //   [];

      const assignedList =
        assignedResp?.data?.data?.data ||
        assignedResp?.data?.devices ||
        assignedResp?.devices ||
        [];

      // const assigned = assignedList.map((d) => ({
      //   id: d.device_id,
      //   name: d.device_name,
      //   isAssigned: true,
      // }));
      const assigned = assignedList.map((d) => ({
        id: d?.id?.id,
        name: d?.name,
        isAssigned: true,
      }));
      console.log(assigned);

      // 2️⃣ Fetch all available/unassigned devices
      const availableResp = await axios.get(
        `${API_URL}/api/get_available_devices_for_customer_assign/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = availableResp.data || {};

      const available = (data.unassigned_devices || []).map((d) => ({
        id: d.id,
        name: d.name,
        isAssigned: false,
      }));

      // Optional safety filter to avoid duplicates
      // const filteredAvailable = available.filter(
      //   (av) => !assigned.some((as) => as.id === av.id)
      // );

      setAssignedDevices(assigned);
      setAvailableDevices(available);
    } catch (err) {
      toast.error("Failed to fetch devices");
      setAssignedDevices([]);
      setAvailableDevices([]);
    } finally {
      setLoading(false);
    }
  };





  //   const fetchDevices = async (customerId) => {
  //   try {
  //     setLoading(true);

  //     const res = await axios.get(
  //       `${API_URL}/api/get_available_devices_for_customer_assign/`,
  //       {
  //         // params: { customer_id: customerId },
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json",
  //         },
  //       }
  //     );

  //     const data = res.data || {};

  //     const assigned = (data.assigned_devices || []).map((d) => ({
  //       id: d.id,
  //       name: d.name,
  //       isAssigned: true,
  //     }));

  //     const available = (data.unassigned_devices || []).map((d) => ({
  //       id: d.id,
  //       name: d.name,
  //       isAssigned: false,
  //     }));

  //     setAssignedDevices(assigned);
  //     setAvailableDevices(available);

  //   } catch (err) {
  //     toast.error("Failed to fetch devices");
  //     setAssignedDevices([]);
  //     setAvailableDevices([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  useEffect(() => {
    if (selectedCustomer) fetchDevices(selectedCustomer);
  }, [selectedCustomer]);


  const handleAction = async (device, action) => {
    const isAssign = action === "assign";

    const endpoint = isAssign
      ? "assign_device_to_customer"
      : "unassign_device_from_customer";

    try {
      await axios.post(
        `${API_URL}/api/${endpoint}/`,
        {
          customer_id: selectedCustomer,
          device_id: device.id,
        },
        getConfig()
      );

      // 🔥 IMPORTANT: ALWAYS REFRESH FROM API
      await fetchDevices(selectedCustomer);

      toast.success(
        `Device ${isAssign ? "assigned" : "unassigned"} successfully`
      );
    } catch (err) {
      // toast.error(err.response?.data?.error || "Action failed");
      const errorData = err.response?.data;

      // extract best possible message
      const errorMessage =
        errorData?.error ||
        errorData?.message ||
        errorData?.details ||
        (typeof errorData === "string" ? errorData : null) ||
        "Action failed";

      if (
        errorMessage.includes("active site") ||
        errorMessage.includes("Cannot unassign")
      ) {
        setConfirmDialog({
          open: true,
          message: errorMessage,
        });
        return;
      }
      toast.error(errorMessage);
    }
  };

  // =============================
  // FILTER TABS
  // =============================
  // const getFilteredDevices = () => {
  //   if (tabValue === 1) return assignedDevices;
  //   if (tabValue === 2) return availableDevices;
  //   return [...assignedDevices, ...availableDevices];
  // };


  const getFilteredDevices = () => {
    if (tabValue === 1) {
      return assignedDevices;
    }

    if (tabValue === 2) {
      return availableDevices.filter(
        (av) => !assignedDevices.some((as) => as.id === av.id)
      );
    }

    // All tab → combine assigned + unassigned without duplicates
    const uniqueAvailable = availableDevices.filter(
      (av) => !assignedDevices.some((as) => as.id === av.id)
    );

    return [...assignedDevices, ...uniqueAvailable];
  };

  return (
    <>
      <Paper className="main-card-ui">
        <Box className="header-row">

          {/* CUSTOMER DROPDOWN (same UI class kept) */}
          <TextField
            select
            label="Select Customer"
            value={selectedCustomer}
            onChange={(e) => {
              setSelectedCustomer(e.target.value);
              setAssignedDevices([]);
              setAvailableDevices([]);
            }}
            size="small"
            className="device-select-input"
          >
            {customers.map((customer) => (
              <MenuItem
                key={customer.tb_customer_id}
                value={customer.tb_customer_id}
              >
                {customer.customer_name}
              </MenuItem>
            ))}
          </TextField>

          <Box className="badge-container">
            <div className="status-badge assigned">
              Assigned: {assignedDevices.length}
            </div>
            <div className="status-badge available">
              Available: {availableDevices.length}
            </div>
          </Box>
        </Box>

        {/* TABS (UNCHANGED UI) */}
        <Box className="tabs-wrapper">
          <Tabs
            value={tabValue}
            onChange={(e, v) => setTabValue(v)}
            centered
            className="custom-tabs"
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            <Tab label="All" />
            <Tab label="Assigned" />
            <Tab label="Available" />
          </Tabs>
        </Box>

        {/* TABLE */}
        <TableContainer className="table-container-ui orange-table">
          {loading ? (
            <Box textAlign="center" p={5}>
              <CircularProgress />
            </Box>
          ) : (
            <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Device Name</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {getFilteredDevices().length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={2}
                      align="center"
                      style={{ padding: "20px", color: "#94a3b8" }}
                    >
                      No devices found.
                    </TableCell>
                  </TableRow>
                ) : (
                  getFilteredDevices()
                    .slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    .map((device) => (
                      <TableRow key={device.id}>
                        <TableCell align="center">
                          {device.name}
                        </TableCell>

                        <TableCell align="center">
                          {device.isAssigned ? (
                            <Button
                              className="btn-unmap"
                              onClick={() =>
                                handleAction(device, "unassign")
                              }
                            >
                              Unassign
                            </Button>
                          ) : (
                            <Button
                              className="btn-map"
                              onClick={() =>
                                handleAction(device, "assign")
                              }
                            >
                              Assign
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          )}

          {/* PAGINATION (UNCHANGED UI) */}
          {!loading && getFilteredDevices().length > 0 && (
            <div className="pagination-bar">
              <div className="rows-select">
                Rows per page:
                <select
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                </select>
              </div>

              <div className="page-info">
                {page * rowsPerPage + 1}-
                {Math.min(
                  (page + 1) * rowsPerPage,
                  getFilteredDevices().length
                )}{" "}
                of {getFilteredDevices().length}
              </div>

              <div className="page-arrows">
                <button
                  disabled={page === 0}
                  onClick={() => setPage(page - 1)}
                >
                  ‹
                </button>

                <button
                  disabled={
                    (page + 1) * rowsPerPage >=
                    getFilteredDevices().length
                  }
                  onClick={() => setPage(page + 1)}
                >
                  ›
                </button>
              </div>
            </div>
          )}
        </TableContainer>
      </Paper>
      <Dialog
  open={confirmDialog.open}
  onClose={() => setConfirmDialog({ open: false, message: "" })}
  className="delete-dialog"
>
  {/* <DialogTitle className="delete-dialog-title">
    Action Blocked
  </DialogTitle> */}

  <DialogContent>
    <DialogContentText className="delete-dialog-text">
      {!confirmDialog.message && "Are you sure?"}
    </DialogContentText>

    {confirmDialog.message && (
      <Box
        sx={{
          mt: 2,
          p: 2,
          borderRadius: 2,
          backgroundColor: "#fdecea",
          color: "#d32f2f",
          fontWeight: 500,
        }}
      >
        {confirmDialog.message}
      </Box>
    )}
  </DialogContent>

  <DialogActions className="delete-dialog-actions">
    <Button
      variant="contained"
      color="primary"
      onClick={() =>
        setConfirmDialog({ open: false, message: "" })
      }
    >
      OK
    </Button>
  </DialogActions>
</Dialog>
      <ToastContainer position="top-right" autoClose={2000} />
    </>
  );
};

export default MapDeviceToCustomer;